// extracted by mini-css-extract-plugin
export default {"wrapper":"PredefinedView_wrapper__3PQCB","implant":"PredefinedView_implant__Lry6y","loading":"PredefinedView_loading__Fo1s0","filters":"PredefinedView_filters__EMb2P"};